import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, catchError, tap, throwError } from 'rxjs';
import { DebugEventService } from './debug-event.service';
import { environment } from 'src/environments/environment';
import { debugTypes } from '../debug-container/debug-container.component';
import { ORDER_RESOURCE_TYPES, OrderService } from './order.service';

@Injectable()
export class HttpreqInterceptor implements HttpInterceptor {
  private readonly debugService = inject(DebugEventService);
  private readonly orderService = inject(OrderService);


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let reqBody = request.body;
    try {
      // attempt to parse as JSON if possible
      if (request.body && typeof request.body === 'string') {
        reqBody = JSON.parse(request.body);
      }
    } catch (error) {
      // it's not a JSON object
      console.log(error);
    }
    return next.handle(request)
      .pipe(
        tap((httpEvent) => {
          if (httpEvent instanceof HttpResponse) {
            this.debugLogEntry(request, reqBody, httpEvent);
          }
        }),
        catchError((error: unknown) => {
          if (error instanceof HttpErrorResponse) {
            this.debugLogEntry(request, reqBody, error);
          }
          return throwError(() => error);
        })
      );
  }

  debugLogEntry(request: HttpRequest<unknown>, requestBody: unknown, response: HttpResponse<unknown> | HttpErrorResponse): void {
    const category = this.createDebugLogTitle(request.url);
    const isHttpResponse = response instanceof HttpResponse;
    const responseToDisplay = isHttpResponse ? response : response.message || '';

    if (category) {
      this.debugService.alert({
        category,
        request: requestBody || request.url,
        response: responseToDisplay,
        type: isHttpResponse && response.ok ? 'success' : 'error'
      });
    }
  }

  createDebugLogTitle(requestUrl: string): debugTypes | "" {
    let title: debugTypes | "" = "";
    const orderListUrls = ORDER_RESOURCE_TYPES.map(type => `${environment.resourceProviderURI}/${type}`);
    if (orderListUrls.includes(requestUrl)) {
      title = "orderList";
    } else if (ORDER_RESOURCE_TYPES.some(type => requestUrl.includes(`/${type}?`))) {
      title = "orderDetail";
    } else if (requestUrl === this.orderService.endpointURLs?.CDSDiscovery ) {
      title = "crd";
    } else if (requestUrl === this.orderService.endpointURLs?.PASSubmit ) {
      title = "pas";
    } else if (requestUrl === this.orderService.endpointURLs?.PASInquiry) {
      title = "pasInquiry"
    } else if (requestUrl.includes('/Group?_profile')) {
      title = "providerAccessGroups"
    } else if (requestUrl.includes('/Group?_include=Group:member')) {
      title = "providerAccessMembers"
    }
    return title;
  }
}
